<template>
  <div class="item-recommended">
    <div class="cover" @click="$emit('handleNext')">
      <img
        class="h-40 w-full object-cover"
        :src="recommendedData.img"
        v-if="recommendedData.img"
        alt="demo"
      />
      <img
        class="h-40 w-full object-cover"
        v-if="!recommendedData.img"
        :src="getImgUrl()"
      />
    </div>
    <div class="content">
      <div  v-if="recommendedData.category" class="label label-grey-200 text-primary">
        {{ recommendedData.category }}
      </div>
      <div v-if="recommendedData.seriesNumber" class="item-id">
        <span>メニューNo. {{ recommendedData.seriesNumber }}</span>
      </div>
      <div v-if="recommendedData.name" class="item-title ">
        <p class="two-lines-ellipsis">{{ recommendedData.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecommendedItem',
  props: {
    recommendedData: {
      type: Object,
      default: null
    },
    handleNext: {
      type: Function
    }
  },
  data() {
    return {}
  },
  methods: {
    getImgUrl() {
      return require('@/assets/images/slide-img-placeholder.png')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
